import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  IconButton,
} from '@mui/material';
import { StyledGrid as Grid } from '../components/StyledGrid';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import ParallaxHeader from '../components/ParallaxHeader';

interface TeamMember {
  name: string;
  role: string;
  image: string;
  bio: string;
  socialMedia?: {
    facebook?: string;
    instagram?: string;
  };
}

const teamMembers: TeamMember[] = [
  {
    name: 'Tabitha (Anton) Spedale',
    role: 'Owner and Master Hair Stylist / Colorist',
    image: '/images/team/tabitha-anton.png',
    bio: `Welcome… I have loved my career since 2010. I am “living the hair life”. I thank all the awesome guest that choose to sit in my chair. My goal is to give each guest an awesome experience. Your hair needs are my hair needs. I want to leave you, wanting to come back for more. Whether I cut, color, style, perm or anything you may desire. Throw it my way so we can play. Satisfaction is the key. You are success.\n\nContact Info:\nSalon Number: 813-591-6538\nCell: 813-526-5791\nEmail: Tabithaanton@stylistinside.com`,
    socialMedia: {
      facebook: 'https://facebook.com/stylistinside',
      instagram: 'https://www.instagram.com/stylistinside.tabithaanton/'
    }
  },
  // Add more team members here as needed
];

const Team = () => {
  return (
    <>
      <ParallaxHeader
        title="Meet Our Team"
        description="Our skilled stylists are passionate about creating your perfect look"
        imageUrl="/images/content/large_bg.png"
        height={300}
      />
      <Box sx={{ py: { xs: 4, md: 6 }, bgcolor: 'background.paper', minHeight: '100vh' }}>
        <Container maxWidth="lg" sx={{ pt: { xs: 2, md: 4 } }}>
          <Grid container spacing={4}>
            {teamMembers.map((member) => (
              <Grid item xs={12} key={member.name}>
                <Card sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, bgcolor: 'white', alignItems: 'stretch', minHeight: { xs: 320, md: 260 }, boxShadow: 3 }}>
                  {/* Portrait on the left */}
                  <CardMedia
                    component="img"
                    image={member.image}
                    alt={member.name}
                    sx={{
                      width: { xs: '100%', md: 240 },
                      height: { xs: 200, md: 280 },
                      objectFit: 'cover',
                      borderRadius: { xs: '8px', md: '8px 0 0 8px' },
                      border: '4px solid #a88685',
                      boxShadow: 2,
                      m: { xs: '24px auto 0 auto', md: 'auto 0 auto 24px' },
                      display: 'block',
                    }}
                  />
                  {/* Info on the right */}
                  <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', p: { xs: 2, md: 3 } }}>
                    <Typography gutterBottom variant="h5" component="h2">
                      {member.name}
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                      {member.role}
                    </Typography>
                    {/* OLA1-1920w image under role */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1 }}>
                      <img src="/images/content/ola1-1920w.jpg" alt="Olaplex" style={{ maxHeight: 200, borderRadius: 8 }} />
                    </Box>
                    <Typography variant="body1" paragraph sx={{ fontSize: { xs: '0.95rem', md: '1rem' } }}>
                      {member.bio.split('\n').map((line, idx) => (
                        <span key={idx}>{line}<br /></span>
                      ))}
                    </Typography>
                    {/* Matrix logo above Book with Tabitha button */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1 }}>
                      <img src="/images/content/Matrix-Logo-1-1920w.png" alt="Matrix Logo" style={{ maxHeight: 200 }} />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                      <a href="https://app.salonrunner.com/customer/directory/index.htm?id=35742" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                        <button style={{
                          background: '#a88685',
                          color: 'white',
                          border: 'none',
                          borderRadius: '20px',
                          padding: '6px 16px',
                          fontWeight: 'bold',
                          cursor: 'pointer',
                          fontSize: '0.95rem',
                        }}>
                          BOOK WITH TABITHA
                        </button>
                      </a>
                      <a href="/prices" style={{ textDecoration: 'none' }}>
                        <button style={{
                          background: '#a88685',
                          color: 'white',
                          border: 'none',
                          borderRadius: '20px',
                          padding: '6px 16px',
                          fontWeight: 'bold',
                          cursor: 'pointer',
                          fontSize: '0.95rem',
                        }}>
                          PRICING
                        </button>
                      </a>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Team;
